import { Button, Form, Input, Modal, Spin } from "antd";
import Title from "antd/es/typography/Title";
import React, { useEffect, useState } from "react";
import { LockOutlined } from "@ant-design/icons";
import { UserProfileAPI } from "../../API/UserProfileAPI";

const validateMessages = {
  required: "${label} is required!",
  types: {
    email: "${label} is not valid!",
  },
};
const validPasswordRgex =
  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{6,14}$/;

function EditPassword({ open, setOpen, messageToast }) {
  const [form] = Form.useForm();
  const [loadSpin, setLoadSpin] = useState(false);

  function backFun() {
    setOpen(false);
  }

  function onFinish(values) {
    const bodyData = {
      current_password: values.currentPassword.trim(),
      new_password: values.newPassword.trim(),
      confirm_new_password: values.confirmPassword.trim(),
    };
    continueChangePswd(bodyData);
  }

  async function continueChangePswd(bodydata) {
    setLoadSpin(true);
    await UserProfileAPI.postChangePassword(bodydata)
      .then((res) => {
        if (res.data.status === true) {
          messageToast("success", res.data?.message);
          form.resetFields();
          setOpen(false);
        } else {
          messageToast("error", res.data?.message);
        }
      })
      .catch(() => messageToast("error", "Internal Server Error"))
      .finally(() => setLoadSpin(false));
  }

  useEffect(() => {
    if (open === true) {
      form.resetFields();
    }
  }, [open]);

  return (
    <Modal
      open={open}
      okText="Apply"
      cancelText="Clear All"
      onCancel={() => backFun()}
      footer={[]}
    >
      <Spin spinning={loadSpin}>
        <div style={{ padding: "10px" }}>
          <div
            style={{
              marginBottom: "20px",
              borderBottom: "solid 1px #80808047",
            }}
          >
            <Title level={5}>Update Password</Title>
          </div>

          <Form
            form={form}
            name="normal_login"
            className="login-form"
            onFinish={onFinish}
            autoComplete="off"
            layout="vertical"
            requiredMark="optional"
            validateMessages={validateMessages}
          >
            <Form.Item
              name="currentPassword"
              label="Current Password"
              rules={[{ required: true }]}
            >
              <Input.Password
                name="currentPassword"
                size="large"
                prefix={<LockOutlined className="site-form-item-icon" />}
                type="password"
              />
            </Form.Item>
            <Form.Item
              name="newPassword"
              label="New Password"
              rules={[
                { required: true },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || validPasswordRgex.test(value)) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        "Password must be 8–14 characters with at least one letter, one number, and one special character."
                      )
                    );
                  },
                }),
              ]}
            >
              <Input.Password
                name="newPassword"
                size="large"
                prefix={<LockOutlined className="site-form-item-icon" />}
                type="password"
              />
            </Form.Item>
            <Form.Item
              name="confirmPassword"
              label="Confirm New Password"
              rules={[
                { required: true },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("newPassword") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        "The new password that you entered do not match!"
                      )
                    );
                  },
                }),
              ]}
            >
              <Input.Password
                name="confirmPassword"
                size="large"
                prefix={<LockOutlined className="site-form-item-icon" />}
                type="password"
              />
            </Form.Item>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <Button
                key="back"
                type="text"
                onClick={backFun}
                style={{ marginRight: "10px" }}
              >
                Cancel
              </Button>
              <Form.Item style={{ margin: 0 }}>
                <Button type="primary" htmlType="submit">
                  Update
                </Button>
              </Form.Item>
            </div>
          </Form>
        </div>
      </Spin>
    </Modal>
  );
}

export default EditPassword;
